import { VALIDATION_NOTIFICATION } from "../../../utils/constants/notification";
import { ElaborationWrapper } from "../../coobjects/ElaborationWrapper";
import React, { FunctionComponent, useState } from "react";
import { PivotObject } from "../../generic/PivotObject";
import { ObjectPanelTabs } from "../../coobjects/co-panel/ObjectPanelComponent";
import { RulesPanel } from "./rule/RulesPanel";
import { TagsPanel } from "./tag/TagsPanel";
import HeaderPanel from "../../layout/HeaderPanel";
import { formatMessage } from "../../../utils/helpers/LanguageHelper";
import { useValidationPanel, ValidationPanelProps } from "./ValidationPanelHook";
import { CommandBarButton, Spinner, SpinnerSize } from "@fluentui/react";
import { AskAiModal } from "./AskAiModal";

const pages: ObjectPanelTabs[] = [
  {
    key: "1",
    name: "cof.base.tags",
    isValid: true,
  },
  {
    key: "2",
    name: "cof.base.rules",
    isValid: true,
  },
];

export const ValidationPanel: FunctionComponent<ValidationPanelProps> = (props) => {
  const documentId = props?.documentPart?.id;
  const { blockingElaboration, pageIndex, isLoading, coObjects, tags, updateTags, rules, updateRules, onClickPivot } =
    useValidationPanel(props);
  const [showAskAiModal, setShowAskAiModal] = useState(false);

  const isRagIndexingEnabled = props?.documentPart?.settings.isRagIndexingEnabled;

  const openAskAI = () => {
    setShowAskAiModal(true);
  };

  let availableTags = tags.filter((t) => !t.isDeleted);

  return (
    <ElaborationWrapper notificationKey={VALIDATION_NOTIFICATION} elaborationItem={blockingElaboration}>
      <HeaderPanel data-testid={"header"} applyPadding headerRowJustifyContent={"space-between"}>
        {formatMessage("cof.base.validation")}
        <>
          {isRagIndexingEnabled && (
            <CommandBarButton
              id={"ask_ai_button"}
              onClick={openAskAI}
              style={{
                border: "2px solid var(--color-blue)",
                borderRadius: "6px",
              }}
            >
              <span style={{ color: "var(--color-blue)", fontWeight: 500 }}>
                {formatMessage("cof.validation.button.openaskai")}
              </span>
            </CommandBarButton>
          )}
        </>
      </HeaderPanel>
      <PivotObject
        isEdit={true}
        selectedKey={pageIndex}
        onClickPivot={onClickPivot}
        items={pages}
        defaultTabName={pages[0].name}
      />
      <div>
        {isLoading ? (
          <div style={{ display: "flex", justifyContent: "center", padding: "24px 0" }}>
            <Spinner data-testid="validation-loading-spinner" size={SpinnerSize.medium} />
          </div>
        ) : pageIndex === 1 ? (
          <TagsPanel
            documentId={documentId}
            coObjects={coObjects}
            tags={availableTags}
            updateTags={updateTags}
            updateRules={updateRules}
          />
        ) : (
          <RulesPanel documentId={documentId} tags={tags} rules={rules} updateRules={updateRules} />
        )}
      </div>
      {showAskAiModal && (
        <AskAiModal
          isShown={showAskAiModal}
          onHide={() => setShowAskAiModal(false)}
          documentId={documentId}
          coObjects={coObjects}
          tags={tags}
          rules={rules}
          updateTags={updateTags}
          updateRules={updateRules}
        />
      )}
    </ElaborationWrapper>
  );
};
